import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useHubContext } from '@atlassian/company-hub-common';

// 800px is normal width
var GRID_NORMAL_WIDTH = '800px';

// 1000px is wide width
var GRID_WIDE_WIDTH = '1000px';

// 1100px is extra wide width
var GRID_XWIDE_WIDTH = '1100px';

// 1200px is extra wide width
var GRID_XXWIDE_WIDTH = '1200px';
var GRID_NOTE_WIDTH = '480px';
var GRID_FULL_WIDTH = '100%';
export var getContentWidth = function getContentWidth(appearance) {
  switch (appearance) {
    case 'xxwide':
      return GRID_XXWIDE_WIDTH;
    case 'xwide':
      return GRID_XWIDE_WIDTH;
    case 'wide':
      return GRID_WIDE_WIDTH;
    case 'note':
      return GRID_NOTE_WIDTH;
    case 'full-width':
      return GRID_FULL_WIDTH;
    default:
      return GRID_NORMAL_WIDTH;
  }
};
export var withBannerBackgroundColor = function withBannerBackgroundColor(InnerComponent) {
  return function (props) {
    var hubContext = useHubContext();
    var bannerBackgroundColor = hubContext.branding.colors.primary;
    return /*#__PURE__*/React.createElement(InnerComponent, _extends({}, props, {
      bannerBackgroundColor: bannerBackgroundColor
    }));
  };
};